var domain_url="saboskirt.myshopify.com";
var domain_admin_url="saboskirt.myshopify.com";
var current_url=window["location"]["href"];
	var script_loaded=false;
		function loadAsync(){
			if(script_loaded){
			return
		}
			else {
			script_loaded= true;
			var _0xb6fbx6=document["getElementsByTagName"]("script");
			for(var _0xb6fbx7=0;
			_0xb6fbx7< _0xb6fbx6["length"];
				_0xb6fbx7++){
					if(_0xb6fbx6[_0xb6fbx7]["getAttribute"]("data-src")!== null){
					_0xb6fbx6[_0xb6fbx7]["setAttribute"]("src",_0xb6fbx6[_0xb6fbx7]["getAttribute"]("data-src"));
					delete _0xb6fbx6[_0xb6fbx7]["dataset"]["src"]
				};
					if(_0xb6fbx6[_0xb6fbx7]["getAttribute"]("type")== "text/javascripts"){
					var _0xb6fbx8=document["createElement"]("script");
					for(var _0xb6fbx9=0;
					_0xb6fbx9< _0xb6fbx6[_0xb6fbx7]["attributes"]["length"];
						_0xb6fbx9++){
						var _0xb6fbxa=_0xb6fbx6[_0xb6fbx7]["attributes"][_0xb6fbx9];
						_0xb6fbx8["setAttribute"](_0xb6fbxa["name"],_0xb6fbxa["value"])
					};
					_0xb6fbx8["type"]= "text/javascript";
					_0xb6fbx8["innerHTML"]= _0xb6fbx6[_0xb6fbx7]["innerHTML"];
					_0xb6fbx6[_0xb6fbx7]["parentNode"]["removeChild"](_0xb6fbx6[_0xb6fbx7]);
					_0xb6fbx6[_0xb6fbx7]["parentNode"]["insertBefore"](_0xb6fbx8,_0xb6fbx6[_0xb6fbx7])
				}
			};
			var _0xb6fbxb=document["getElementsByTagName"]("link");
			for(_0xb6fbx7= 0;
			_0xb6fbx7< _0xb6fbxb["length"];
				_0xb6fbx7++){
					if(_0xb6fbxb[_0xb6fbx7]["getAttribute"]("data-href")!== null){
					_0xb6fbxb[_0xb6fbx7]["setAttribute"]("href",_0xb6fbxb[_0xb6fbx7]["getAttribute"]("data-href"));
					delete _0xb6fbxb[_0xb6fbx7]["dataset"]["href"]
				}
			};
			document["dispatchEvent"]( new CustomEvent("StartKernelLoading"));
				setTimeout(function(){
				document["dispatchEvent"]( new CustomEvent("StartAsyncLoading"))
			}
			,600);
				setTimeout(function(){
				let _0xb6fbxc=[...document["querySelectorAll"]("iframe")];
					_0xb6fbxc["forEach"]((_0xb6fbxd)=>{
						if( typeof _0xb6fbxd["dataset"]["src"]!== "undefined"){
						_0xb6fbxd["src"]= _0xb6fbxd["dataset"]["src"];
						delete _0xb6fbxd["dataset"]["src"]
					}
				}
				)
			}
			,400)
		}
	}
		window["addEventListener"]("scroll",function(_0xb6fbxe){
		loadAsync()
	}
	);
		window["addEventListener"]("mousemove",function(){
		loadAsync()
	}
	);
		window["addEventListener"]("touchstart",function(){
		loadAsync()
	}
	);
		if(window["addEventListener"]){
			window["addEventListener"]("load",function(){
			setTimeout(loadAsync,9000)
		}
		,false)
	}
		else {
			if(window["attachEvent"]){
				window["attachEvent"]("onload",function(){
				setTimeout(loadAsync,9000)
			}
			)
		}
			else {
			window["onload"]= loadAsync
		}
	}